module.exports = __webpack_public_path__ + "static/img/13.e59e47c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/sp/13.png
// module id = N/Ov
// module chunks = 0